import { render, staticRenderFns } from "./OverviewSilhouette.vue?vue&type=template&id=355f0adc&"
import script from "./OverviewSilhouette.vue?vue&type=script&lang=js&"
export * from "./OverviewSilhouette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports